export default "__VITE_ASSET__Dwa5yG_L__"